import styled from 'styled-components';

export const PAGE_CONTAINER_PADDINGS = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
};
const PAGE_CONTAINER_PADDINGS_SEQUENCE = [
  PAGE_CONTAINER_PADDINGS.TOP,
  PAGE_CONTAINER_PADDINGS.RIGHT,
  PAGE_CONTAINER_PADDINGS.BOTTOM,
  PAGE_CONTAINER_PADDINGS.LEFT,
];
export const PAGE_CONTAINER_PADDING_PREFIX_VAR = '--page-container-padding-';
const DEFAULT_PAGE_CONTAINER_PADDING_VALUE = '20px';
const PAGE_CONTAINER_PADDING = PAGE_CONTAINER_PADDINGS_SEQUENCE.map((position) => {
  return `var(${PAGE_CONTAINER_PADDING_PREFIX_VAR}${position})`;
}).join(' ');

export const Container = styled.div`
  ${({ hasBottom }) => {
    return PAGE_CONTAINER_PADDINGS_SEQUENCE.reduce((acc, position) => {
      const isBottomValue = position === PAGE_CONTAINER_PADDINGS.BOTTOM;
      const value = isBottomValue && hasBottom ? '0' : DEFAULT_PAGE_CONTAINER_PADDING_VALUE;

      acc.push(`${PAGE_CONTAINER_PADDING_PREFIX_VAR}${position}: ${value};`);

      return acc;
    }, []).join(' ');
  }}

  display: flex;
  flex-direction: column;

  row-gap: 24px;

  min-height: 100%;

  background-color: var(--color-grey-1);

  box-sizing: border-box;
  padding: ${PAGE_CONTAINER_PADDING};
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: ${({ hasAside }) => {
    let result = 'auto';

    if (hasAside) {
      result = '1fr 332px';
    }

    return result;
  }};
  grid-column-gap: 24px;

  max-width: 1298px;

  margin-top: ${({ isBottom }) => {
    let result = 'none';

    if (isBottom) {
      result = 'auto';
    }

    return result;
  }};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  row-gap: 24px;
`;

export const Aside = styled.div`
  display: flex;
  flex-direction: column;

  row-gap: 16px;

  position: sticky;
`;
